export const pageMetaOverviewSelector = (state) => state.pageMetaOverview;
